import { render, staticRenderFns } from "./frontabnormalreceivingorder-list.vue?vue&type=template&id=c48a69ba&scoped=true&"
import script from "./frontabnormalreceivingorder-list.vue?vue&type=script&lang=ts&"
export * from "./frontabnormalreceivingorder-list.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c48a69ba",
  null
  
)

export default component.exports